<h3>Основной список файлов</h3>

<pa-file-list [files]="sampleFiles" buttonLabel="Файлы к договору" buttonIcon="pi pi-chevron-down"
  buttonSeverity="secondary">
</pa-file-list>


<h3>Большой список файлов</h3>

<pa-file-list [files]="largeFilesList" buttonLabel="Документы проекта" buttonIcon="pi pi-folder-open"
  buttonSeverity="info">
</pa-file-list>